import { type Maybe } from "@oefr/utils/types"

export function isPrmCommunicating(serviceLevel: Maybe<number>) {
    if (!serviceLevel) return false

    return serviceLevel >= 1
}
